import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7838fa1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portrait-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portrait-title" }, "节能评分", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的节能", -1))
const _hoisted_4 = { class: "page-box portrait-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "空调调节", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开关照明", -1))
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "portrait-count",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goEnergyDetail('energy')))
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.energyData.totalPoints || _ctx.energyData.totalPoints == 0 ? _ctx.energyData.totalPoints : '--'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.energyArr[0].isshow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "box",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEnergyDetail('air')))
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.energyArr[0].num), 1),
            _createElementVNode("img", {
              src: _ctx.parseImgUrl('page-portrait','portrait_air.svg'),
              alt: ""
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (_ctx.energyArr[1].isshow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "box",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goEnergyDetail('lamp')))
          }, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.energyArr[1].num), 1),
            _createElementVNode("img", {
              class: "temp-img",
              src: _ctx.parseImgUrl('page-portrait','portrait_lamp.svg'),
              alt: ""
            }, null, 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}